'use strict';

import Urls from './Urls';
import { FEATURE_APPOINTMENT, FEATURE_BIOBANK, isFeatureOn } from './Config';
import WindowUtils from '../utils/WindowUtils';
import SessionUtils from '../utils/SessionUtils';

export default (features, isHpa) => {
  let isMobile = WindowUtils.screenWidth() <= 879;
  const logout = () => SessionUtils.logout();

  let navigationItems = [
    {
      message: 'navigation.timeline',
      disabled: false,
      icon: {
        type: 'custom',
        name: 'minun-hoitoni',
      },
      link: '/timeline',
      key: 'timeline',
    },
    {
      message: 'navigation.questionnaires',
      disabled: false,
      icon: {
        type: 'custom',
        name: 'kyselyt',
      },
      link: '/questionnaires',
      key: 'questionnaires',
    },
    {
      message: 'navigation.appointments',
      disabled: !isFeatureOn(FEATURE_APPOINTMENT),
      icon: {
        type: 'custom',
        name: 'ajanvaraus',
      },
      link: '/appointments',
      key: 'appointments',
    },
    {
      message: 'navigation.services',
      disabled: false,
      icon: {
        type: 'custom',
        name: 'palvelut',
      },
      link: '/services',
      key: 'services',
    },
    {
      message: 'navigation.careconversations',
      disabled: false,
      icon: {
        type: 'custom',
        name: 'hoitokeskustelu',
      },
      link: '/careconversations',
      key: 'careconversations',
    },
    /*

     IOTAYS-726

     {
       message: "navigation.guides",
       disabled: false,
       icon: {
         type:"custom",
         name:"potilasohjeet"
       },
       link: "/guides",
       key: "guides"
     },*/

    {
      type: 'custom',
      message: 'navigation.feedback',
      disabled: false,
      isOpen: false,
      icon: {
        type: 'custom',
        name: 'palaute',
      },
      key: 'feedback',
      items: [
        {
          message: 'navigation.feedback.item1',
          isExternal: true,
          icon: '',
          modal: {
            link: Urls.timelineFeedback,
            text: [
              'navigation.feedback.item1.modal.p1',
              'navigation.feedback.item1.modal.p2',
            ],
            target: '_blank',
          },
        },
        {
          message: 'navigation.feedback.item2',
          isExternal: true,
          icon: '',
          modal: {
            link: Urls.timelineNoticeOfDefect,
            text: [
              'navigation.feedback.item2.modal.p1',
              'navigation.feedback.item2.modal.p2',
            ],
            target: '_blank',
          },
        },
        {
          message: 'navigation.feedback.item3',
          isExternal: true,
          icon: '',
          modal: {
            link: Urls.timelineTreatmentFeedback,
            text: [
              'navigation.feedback.item3.modal.p1',
              'navigation.feedback.item3.modal.p2',
            ],
            target: '_blank',
          },
        },
      ],
    },
    {
      message: 'navigation.omakanta',
      disabled: false,
      icon: {
        type: 'fa',
        name: 'icon-long-arrow-right',
      },
      link: Urls.omaKanta,
      isExternal: true,
      target: '_blank',
      key: 'omakanta',
      color: 'green',
    },
  ];

  if (isMobile) {
    navigationItems.splice(
      navigationItems.length,
      0,
      {
        message: 'user.viewinfo',
        disabled: !isMobile,
        icon: {
          type: 'custom',
          name: 'profiili',
        },
        link: '/userinfo',
        key: 'viewinfo',
      },
      {
        type: 'logout',
        message: 'logout',
        disabled: !isMobile,
        icon: {
          type: 'fa',
          name: 'icon-signout',
        },
        link: Urls.logout(),
        IsLogout: true,
        key: 'logout',
        logout: true,
      }
    );
  }

  if (isFeatureOn(FEATURE_BIOBANK)) {
    // put betweeh "careconversations" and "appointments"
    navigationItems.splice(6, 0, {
      message: 'navigation.biobank',
      disabled: false,
      icon: {
        type: 'custom',
        name: 'sopimus',
      },
      link: '/biobank',
      key: 'biobank',
    });
  }

  return navigationItems;
};
